import React, { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import WorkflowDesign from "./WorkflowDesign";
import { getWfPhasesColor } from "../services/appService";

const getPhaseIcon = (phase) => {
  switch (phase) {
    case "Approved": return "fa-check-circle";
    case "Denied": case "Rejected": return "fa-times-circle";
    case "Application": return "fa-file-text-o";
    case "Onboarding": return "fa-user-plus";
    case "Review": return "fa-check-square-o";
    case "Compliance": return "fa-shield";
    case "Time Log": return "fa-clock-o";
    case "Invoice": return "fa-file-text";
    case "Pending": return "fa-hourglass-half";
    default: return "fa-tag";
  }
};

const WorkflowMapPopup = ({ selectedObj: propSelectedObj, workflowShowHide, handleWorkflowModalShowHide }) => {
  const [selectedObj, setSelectedObj] = useState({});
  const myRef = useRef(null);

  useEffect(() => {
    setSelectedObj(propSelectedObj);
  }, [propSelectedObj]);

  if (!workflowShowHide) return null;

  const handleClose = () => {
    handleWorkflowModalShowHide("");
  };

  const candidateName = selectedObj?.performerName || selectedObj?.applicantName || selectedObj?.name || "";
  const email = selectedObj?.performerEmail || selectedObj?.applicantEmail || selectedObj?.email || "";
  const phone = selectedObj?.performerPhone || selectedObj?.phone || selectedObj?.cellPhone || "";
  const phase = selectedObj?.wfPhase || selectedObj?.currentTask;
  const phaseClass = phase === "Application"
    ? "btn-wf2-default"
    : (getWfPhasesColor(phase) || "btn-default");
  const themeClass = phaseClass.replace("btn-", "theme-");

  return (
    <Modal
      show={Boolean(workflowShowHide)}
      onHide={handleClose}
      size="xl"
      dialogClassName={`rt-tools-modal rt-workflow-map-modal ${themeClass}`}
      centered
    >
      <style>{`
        /* Ensure the modal and backdrop are on top of sidebars/headers */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
        }

        .rt-workflow-map-modal {
          max-width: 90% !important;
          width: 1200px !important;
        }

        .rt-workflow-map-modal .modal-content {
          border-radius: 0 !important;
          box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1), 0 8px 10px -6px rgba(0,0,0,0.1) !important;
          border: 1px solid #cbd5e1 !important;
          overflow: hidden !important;
          background: #ffffff !important;
          font-family: inherit !important;
        }

        .rt-workflow-map-modal .modal-header {
          position: relative !important;
          padding: 16px 20px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
        }

        .rt-workflow-map-modal .rt-header-shell {
          width: 100% !important;
        }

        .rt-workflow-map-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 12px !important;
        }

        .rt-workflow-map-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex: 1 !important;
        }

        .rt-workflow-map-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 4px !important;
          min-width: 0 !important;
        }

        .rt-workflow-map-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #1e293b !important;
          font-size: 18px !important;
          font-weight: 500 !important;
          line-height: 1.2 !important;
          min-width: 0 !important;
        }

        .rt-workflow-map-modal .rt-header-icon {
          width: 52px !important;
          height: 52px !important;
          min-height: 52px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 2px 6px -2px rgba(15,23,42,0.08) !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }

        .rt-workflow-map-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 12px !important;
          min-width: 0 !important;
          flex-wrap: wrap !important;
        }

        .rt-workflow-map-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          gap: 5px !important;
          padding: 3px 8px !important;
          height: 22px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11px !important;
          font-weight: 600 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.02em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
          line-height: 1 !important;
        }
        .rt-workflow-map-modal .rt-modal-title-badge i {
          font-size: 10.5px !important;
        }
        .rt-workflow-map-modal .rt-modal-title-badge.btn-primary { background: #eff6ff !important; color: #2563eb !important; border-color: #bfdbfe !important; }
        .rt-workflow-map-modal .rt-modal-title-badge.btn-info { background: #ecfeff !important; color: #0891b2 !important; border-color: #a5f3fc !important; }
        .rt-workflow-map-modal .rt-modal-title-badge.btn-warning { background: #fffbeb !important; color: #d97706 !important; border-color: #fde68a !important; }
        .rt-workflow-map-modal .rt-modal-title-badge.btn-success { background: #f0fdf4 !important; color: #16a34a !important; border-color: #bbf7d0 !important; }
        .rt-workflow-map-modal .rt-modal-title-badge.btn-wf2-default { background: #fef9c3 !important; color: #ca8a04 !important; border-color: #fef08a !important; }
        .rt-workflow-map-modal .rt-modal-title-badge.btn-wf3-default { background: #ecfdf5 !important; color: #059669 !important; border-color: #a7f3d0 !important; }
        .rt-workflow-map-modal .rt-modal-title-badge.btn-wf4-default { background: #fef2f2 !important; color: #dc2626 !important; border-color: #fecaca !important; }
        .rt-workflow-map-modal .rt-modal-title-badge.btn-wf5-default { background: #fff7ed !important; color: #ea580c !important; border-color: #fed7aa !important; }
        .rt-workflow-map-modal .rt-modal-title-badge.btn-wf6-default { background: #f5f3ff !important; color: #7c3aed !important; border-color: #ddd6fe !important; }
        .rt-workflow-map-modal .rt-modal-title-badge.btn-default,
        .rt-workflow-map-modal .rt-modal-title-badge.btn-wf-default { background: #f1f5f9 !important; color: #475569 !important; border-color: #cbd5e1 !important; }

        .rt-workflow-map-modal .rt-modal-meta-row {
          display: flex !important;
          align-items: center !important;
          flex-wrap: wrap !important;
          gap: 8px !important;
          margin-top: 0 !important;
          padding-left: 0 !important;
          font-size: 12px !important;
          font-weight: 400 !important;
          color: #64748b !important;
        }

        .rt-workflow-map-modal .rt-meta-chip {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          background: #ffffff !important;
          padding: 3px 8px !important;
          height: 24px !important;
          min-height: 24px !important;
          box-sizing: border-box !important;
          border-radius: 0 !important;
          font-size: 11.5px !important;
          font-weight: 500 !important;
          color: #0f172a !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: none !important;
          line-height: 1 !important;
        }

        .rt-workflow-map-modal .rt-meta-chip i,
        .rt-workflow-map-modal .rt-meta-chip .fa {
          font-size: 11.5px !important;
          margin-right: 4px !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
        }

        .rt-workflow-map-modal .rt-meta-chip i.fa-user { color: #9333ea !important; }
        .rt-workflow-map-modal .rt-meta-chip i.fa-envelope, .rt-workflow-map-modal .rt-meta-chip i.fa-envelope-o { color: #0284c7 !important; }
        .rt-workflow-map-modal .rt-meta-chip i.fa-phone { color: #16a34a !important; }
        .rt-workflow-map-modal .rt-meta-chip i.fa-tasks, .rt-workflow-map-modal .rt-meta-chip i.fa-database { color: #2563eb !important; }
        .rt-workflow-map-modal .rt-meta-chip i.fa-info-circle { color: #0891b2 !important; }
        .rt-workflow-map-modal .rt-meta-chip i.fa-id-badge { color: #6366f1 !important; }
        .rt-workflow-map-modal .rt-meta-chip i.fa-hashtag { color: #d97706 !important; }

        .rt-workflow-map-modal .modal-body {
          padding: 20px 24px !important;
          background: #ffffff !important;
          max-height: calc(100vh - 200px) !important;
          overflow-y: auto !important;
        }

        /* Close Button */
        .rt-workflow-map-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          padding: 0 !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
          font-family: inherit !important;
        }
        .rt-workflow-map-modal .rt-action-btn:hover {
          color: #dc2626 !important;
          border-color: #fca5a5 !important;
          background: #fef2f2 !important;
          transform: translateY(-1px) !important;
        }

        /* Modal Footer */
        .rt-workflow-map-modal .modal-footer {
          background: #ffffff !important;
          border-top: 1px solid #e2e8f0 !important;
          padding: 14px 20px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 10px !important;
        }
        .rt-workflow-map-modal .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 4px !important;
          padding: 7px 18px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
          cursor: pointer !important;
          transition: all 0.15s ease !important;
          font-family: inherit !important;
        }
        .rt-workflow-map-modal .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 2px 4px rgba(15, 23, 42, 0.08) !important;
        }

        .rt-workflow-canvas-viewport {
          position: relative;
          width: 100%;
          height: 600px;
          overflow: auto;
          border: 1px solid #e2e8f0;
          border-radius: 0;
          background-color: #f8fafc;
          background-image: 
            radial-gradient(circle, rgba(148, 163, 184, 0.15) 1px, transparent 1px);
          background-size: 24px 24px;
        }

        .rt-workflow-canvas-viewport::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .rt-workflow-canvas-viewport::-webkit-scrollbar-track {
          background: #f1f5f9;
        }

        .rt-workflow-canvas-viewport::-webkit-scrollbar-thumb {
          background: #cbd5e1;
        }

        .rt-workflow-canvas-viewport::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }

        .rt-workflow-canvas-viewport > div[style*="absolute"] {
          position: absolute !important;
          top: 16px !important;
          left: 16px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          padding: 10px 14px !important;
          border-radius: 0 !important;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;
          display: grid !important;
          grid-template-columns: auto 1fr !important;
          align-items: center !important;
          gap: 6px 10px !important;
          z-index: 10 !important;
        }

        .rt-workflow-canvas-viewport > div[style*="absolute"] br {
          display: none !important;
        }

        .rt-workflow-canvas-viewport > div[style*="absolute"] img {
          width: 14px !important;
          height: 14px !important;
          object-fit: contain !important;
          margin: 0 !important;
        }

        .rt-workflow-canvas-viewport > div[style*="absolute"] span {
          font-size: 11px !important;
          font-weight: 600 !important;
          color: #1e293b !important;
          margin: 0 !important;
        }

        .rt-workflow-canvas-viewport .text-green {
          color: #10b981 !important;
        }

        .rt-workflow-canvas-viewport .text-red {
          color: #ef4444 !important;
        }
      `}</style>

      <Modal.Header>
        <div className="rt-header-shell">
          <div className="rt-header-top">
            <div className="rt-header-main">
              <i className="rt-header-icon fa fa-sitemap" aria-hidden="true" />
              <div className="rt-header-copy">
                <h2 className="rt-modal-title">
                  <span className="rt-modal-title-text">
                    <span>Workflow Map View</span>
                    {phase && (
                      <span className="rt-modal-title-badge">
                        {phase}
                      </span>
                    )}
                  </span>
                </h2>
                <div className="rt-modal-meta-row">
                  {candidateName && (
                    <span className="rt-meta-chip">
                      <i className="fa fa-user" aria-hidden="true" style={{ color: "#9333ea", marginRight: "4px" }} />
                      <span>{candidateName}</span>
                    </span>
                  )}
                  {email && (
                    <span className="rt-meta-chip">
                      <i className="fa fa-envelope" aria-hidden="true" style={{ color: "#0284c7", marginRight: "4px" }} />
                      <span>{email}</span>
                    </span>
                  )}
                  {phone && (
                    <span className="rt-meta-chip">
                      <i className="fa fa-phone" aria-hidden="true" style={{ color: "#16a34a", marginRight: "4px" }} />
                      <span>{phone}</span>
                    </span>
                  )}
                  <span className="rt-meta-chip">
                    <i className="fa fa-tasks" aria-hidden="true" style={{ color: "#2563eb", marginRight: "4px" }} />
                    <span>Process ID: {selectedObj?.ciid || "N/A"}</span>
                  </span>
                  <span className="rt-meta-chip">
                    <i className="fa fa-info-circle" aria-hidden="true" style={{ color: "#0891b2", marginRight: "4px" }} />
                    <span>Task Name: {selectedObj?.itemName || selectedObj?.currentTask || "N/A"}</span>
                  </span>
                </div>
              </div>
            </div>
            <button
              type="button"
              className="rt-action-btn"
              onClick={handleClose}
              title="Close Map"
            >
              <i className="fa fa-times" aria-hidden="true" />
            </button>
          </div>
        </div>
      </Modal.Header>
      
      <Modal.Body>
        <div className="rt-workflow-canvas-viewport">
          {selectedObj?.ciid && <WorkflowDesign selectedObj={selectedObj} />}
          <div ref={myRef} />
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="wf-modal-footer-close-btn"
          onClick={handleClose}
        >
          <i className="fa fa-times" aria-hidden="true" /> Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default WorkflowMapPopup;
